import React from 'react';
import { Typography } from '@/lib/typography';
import { Lightbulb, Target, BookOpen } from '@phosphor-icons/react';

export function IntelligencePanel() {
  // Mock data - matches final DTO shape from §6.1
  const intelligence = {
    ideas: { generated: 12, scaffolded: 5, promoted: 3 },
    campaigns: { active: 4, sent: 15, replies: 8 },
    kb: { articles: 23, last_publish_days_ago: 12, drafts: 7 }
  };

  return (
    <div className="bg-white rounded-lg border border-brand-100 p-6">
      <h2 className={Typography.h2}>
        Intelligence
      </h2>

      {/* Ideas Section */}
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 rounded-lg bg-modules-ideas flex items-center justify-center">
            <Lightbulb className="w-4 h-4 text-green-700" />
          </div>
          <h3 className="font-heading text-brand-950">Ideas</h3>
        </div>
        <div className="grid grid-cols-3 gap-4 pl-10">
          <div>
            <p className="font-heading text-brand-950">
              {intelligence.ideas.generated}
            </p>
            <p className="text-slate-500">Generated</p>
          </div>
          <div>
            <p className="font-heading text-brand-950">
              {intelligence.ideas.scaffolded}
            </p>
            <p className="text-slate-500">Scaffolded</p>
          </div>
          <div>
            <p className="font-heading text-brand-950">
              {intelligence.ideas.promoted}
            </p>
            <p className="text-slate-500">Promoted</p>
          </div>
        </div>
      </div>

      {/* Campaigns Section */}
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 rounded-lg bg-modules-campaigns flex items-center justify-center">
            <Target className="w-4 h-4 text-amber-600" />
          </div>
          <h3 className="font-heading text-brand-950">Campaigns</h3>
        </div>
        <div className="grid grid-cols-3 gap-4 pl-10">
          <div>
            <p className="font-heading text-brand-950">
              {intelligence.campaigns.active}
            </p>
            <p className="text-slate-500">Active</p>
          </div>
          <div>
            <p className="font-heading text-brand-950">
              {intelligence.campaigns.sent}
            </p>
            <p className="text-slate-500">Sent</p>
          </div>
          <div>
            <p className="font-heading text-brand-950">
              {intelligence.campaigns.replies}
            </p>
            <p className="text-slate-500">Replies</p>
          </div>
        </div>
      </div>

      {/* Knowledge Base Section */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 rounded-lg bg-modules-kb flex items-center justify-center">
            <BookOpen className="w-4 h-4 text-brand-900" />
          </div>
          <h3 className="font-heading text-brand-950">Knowledge Base</h3>
        </div>
        <div className="grid grid-cols-3 gap-4 pl-10">
          <div>
            <p className="font-heading text-brand-950">
              {intelligence.kb.articles}
            </p>
            <p className="text-slate-500">Articles</p>
          </div>
          <div>
            <p className="font-heading text-brand-950">
              {intelligence.kb.last_publish_days_ago}
            </p>
            <p className="text-slate-500">Days Since Publish</p>
          </div>
          <div>
            <p className="font-heading text-brand-950">
              {intelligence.kb.drafts}
            </p>
            <p className="text-slate-500">Drafts</p>
          </div>
        </div>
      </div>
    </div>
  );
}
